// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import SocialSharing from 'vue-social-sharing';
import Components from "./components/components";

Vue.use(ElementUI);
Vue.use(SocialSharing);
Vue.use(Components);

import Group from '@/assets/lib/group';
import Verify from '@/assets/lib/verify';

Vue.prototype.$group = Group;
Vue.prototype.$verify = Verify;

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js